import React, { useEffect } from 'react';
import CustomerSelect from '../../../CustomerSelect/Facelift';
import { TMinimalDescribeICustomer } from '../../../../store/ducks/customers/types';
import { ILongSteelOrdersState } from '../../../../store/ducks/long-steel-orders/types';
import { INewLongSteelOrdersState } from '../../../../store/ducks/new-long-steel-orders/types';
import { InvoicesState } from '../../../../store/ducks/invoices/types';

interface IShipToViewProps {
  orderOrInvoiceState:
    | ILongSteelOrdersState
    | INewLongSteelOrdersState
    | InvoicesState;
  isUserAdmin: boolean;
  emitterIds: string[];
  setEmitterIds(emitterIds: string[]): void;
  receiverId?: string;
  setReceiverId?(receiverId: string): void;
  receiverIds?: string[];
  setReceiverIds?(receiverIds: string[]): void;
  customers: TMinimalDescribeICustomer[];
  placeholder?: string;
  onBlurReceivers?: () => void;
  showRichDisplay?: boolean;
}

const ShipToView: React.FC<IShipToViewProps> = ({
  orderOrInvoiceState,
  receiverId,
  setReceiverId,
  receiverIds,
  setReceiverIds,
  customers,
  placeholder,
  onBlurReceivers,
  showRichDisplay
}) => {
  useEffect(() => {
    if (setReceiverId && customers.length === 1 && !receiverId) {
      setReceiverId(customers[0].customerId);
    }
  }, []);

  return (
    <>
      {setReceiverId && (
        <CustomerSelect
          title={'Recebedor do pedido'}
          placeholder={placeholder ?? 'Selecionar recebedor'}
          disabled={orderOrInvoiceState.loading}
          customers={customers}
          onSelect={setReceiverId}
          selectedCustomerId={receiverId}
          customStyles={{ selectTitleFontSize: '0.8rem' }}
          onBlur={onBlurReceivers}
          showRichDisplay={showRichDisplay}
        />
      )}
      {setReceiverIds && (
        <CustomerSelect
          title={'Recebedores do pedido'}
          placeholder={placeholder ?? 'Selecionar recebedores'}
          disabled={orderOrInvoiceState.loading}
          customers={customers}
          onSelectMultiple={setReceiverIds}
          selectedCustomerIds={receiverIds}
          isMultipleSelect={true}
          customStyles={{ selectTitleFontSize: '0.8rem' }}
          onBlur={onBlurReceivers}
        />
      )}
    </>
  );
};

export default ShipToView;
